/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { TreeView } from '@neo4j-ndl/react';
import {
  ChevronDownIconSolid,
  ChevronUpIconSolid,
  FolderIconOutline,
} from '@neo4j-ndl/react/icons';
import type React from 'react';
import { useState } from 'react';

const TREE_ITEMS: React.ComponentProps<typeof TreeView>['items'] = [
  {
    canHaveSubItems: true,
    data: {
      custom: 'Custom Root',
    },
    id: 'Root',
    isCollapsed: false,
    isSelected: false,
    subItems: [
      {
        canHaveSubItems: false,
        data: {
          custom: 'Custom child 1',
        },
        id: 'Child 1',
        isSelected: false,
      },
      {
        canHaveSubItems: false,
        data: {
          custom: 'Custom child 2',
        },
        id: 'Child 2',
        isSelected: false,
      },
      {
        canHaveSubItems: false,
        data: {
          custom: 'Custom child 3',
        },
        id: 'Child 3',
        isSelected: false,
      },
    ],
  },
];

const Component = () => {
  const [items, setItems] = useState(TREE_ITEMS);

  return (
    <TreeView
      items={items}
      onItemsChanged={(newItems) => {
        setItems(newItems);
      }}
      TreeItemComponent={function CustomTreeItem({
        ref,
        onItemsChanged,
        ...restProps
      }: React.ComponentProps<typeof TreeView.TreeItemWrapper>) {
        return (
          <TreeView.TreeItemWrapper
            {...restProps}
            onItemsChanged={onItemsChanged}
            ref={ref}
          >
            <div
              className="n-items-center n-flex n-flex-row"
              style={{
                background: !restProps.item.canHaveSubItems
                  ? 'linear-gradient(in hsl longer hue 45deg, red 0 0)'
                  : '',
              }}
            >
              {restProps.item.canHaveSubItems && (
                <>
                  <FolderIconOutline className="n-h-5 w-h-5" />
                  <button
                    type="button"
                    onClick={() =>
                      restProps.onCollapse && restProps.onCollapse()
                    }
                  >
                    {restProps.item.isCollapsed ? (
                      <ChevronUpIconSolid className="n-h-5 w-h-5" />
                    ) : (
                      <ChevronDownIconSolid className="n-h-5 w-h-5" />
                    )}
                  </button>
                </>
              )}
              {'custom' in restProps.item.data &&
                typeof restProps.item.data.custom === 'string' &&
                restProps.item.data.custom}
            </div>
          </TreeView.TreeItemWrapper>
        );
      }}
    />
  );
};

export default Component;
